<template>
    <v-container>
        <configuracao-limite-cotas-reserva :limite-cotas-para-reservar-ativo.sync="limite_cotas_para_reservar_ativo"
                                           :quantidade-cotas-reservar.sync="quantidade_cotas_reservar" />
        <v-divider />
        <configuracao-limite-cotas-fluxo-comum
                :limite-cotas-fluxo-comum-ativo.sync="percentual_cotas_disponiveis_ativo"
                :limite-cotas-fluxo-comum.sync="percentual_cotas_disponiveis"
        />
        <v-card-text>
            <h3>Configuração de pagamento</h3>
            <v-row>
                <v-col cols="12" md="4">
                    <MoneyTextField
                            ref="percentual_participacao"
                            label="Percentual máximo:"
                            class="required"
                            :disabled="!switch1"
                            outlined
                            maxlength="18"
                            v-model="porcentagem"
                            :rules="[$rules.required]"
                            :options="{locale: 'pt-BR',suffix: '%',precision: 2,prefix: ''}"
                            maxvalue="100" />
                </v-col>
                <v-col cols="12" md="6">
                    <v-switch v-model="switch1" :label="`Habilitar/Desabilitar`"></v-switch>
                </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="inserir">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <h3>Configuração de idade mínima</h3>
            <v-row style="margin-top: 15px">
                <v-col cols="12" md="4">
                    <m-text-field label="Idade mínima para venda:" class="required" outlined v-input-filter="[$filters.numeric]" v-model="valor_idade" maxlength="3" :rules="[$rules.required, $rules.idadeMaxima150]" />
                </v-col>
                <v-col cols="12" md="6"> </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="inserirIdade">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <h3>Limite de comprometimento da renda</h3>
            <v-row style="margin-top: 15px">
                <v-col cols="12" md="4">
                    <MoneyTextField ref="percentual_minimo_venda" id="FieldPercentualMinimoVenda" label="Percentual mínimo para venda" class="required" outlined maxlength="4" v-model="percentual_minimo_venda" :rules="[$rules.required]" :options="{ locale: 'pt-BR', suffix: '%', precision: 0, prefix: '' }" maxvalue="100" />
                    <p style="margin-top: -20px; margin-left: 5px; font-size: 12px">
                        <label>Percentual mínimo configurado relacionado ao valor da parcela do bem</label>
                    </p>
                </v-col>
                <v-col cols="12" md="6"> </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="salvarLimiteComprometimentoRenda">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <h3>Limite de comprometimento de faturamento</h3>
            <v-row style="margin-top: 15px">
                <v-col cols="12" md="4">
                    <MoneyTextField ref="percentual_minimo_faturamento" id="FieldPercentualMinimoFaturamento" label="Percentual mínimo para venda" class="required" outlined maxlength="4" v-model="percentual_minimo_faturamento" :rules="[$rules.required]" :options="{ locale: 'pt-BR', suffix: '%', precision: 0, prefix: '' }" maxvalue="100" />
                    <p style="margin-top: -20px; margin-left: 5px; font-size: 12px">
                        <label>Percentual mínimo configurado relacionado ao valor da parcela do bem</label>
                    </p>
                </v-col>
                <v-col cols="12" md="6"> </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="salvarLimiteComprometimentoFaturamento">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <h3>Configuração de obrigatoriedade da assinatura</h3>
            <v-row>
                <v-col cols="12" md="4">
                    <h4 class="text--gray">
                        Assinatura obrigatória para Grupos Pontuais?
                    </h4>
                </v-col>
                <v-col cols="12" md="4">
                    <v-switch v-model="assinatura_obrigatoria_grupos_pontuais" :label="`Habilitar/Desabilitar`"></v-switch>
                </v-col>
            </v-row>
            <v-row style="margin-top: 15px">
                <v-col cols="12" md="4">
                    <h4 class="text--gray">
                        Assinatura obrigatória para Grupos Convencionais?
                    </h4>
                </v-col>
                <v-col cols="12" md="6">
                    <v-switch v-model="assinatura_obrigatoria_grupos_convencionais" :label="`Habilitar/Desabilitar`"></v-switch>
                </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded @click="inserirAssinaturaObrigatoria">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-divider />
        <v-card-text>
            <div class="funcionalidade-container">
                <h3>Restrição de funcionalidades do sistema</h3>
                <v-row>
                    <v-col cols="12" md="4" class="d-flex">
                        <h4 class="text--gray parametros__sistema__h4">
                            Acessar via Tela de Login do AFV
                        </h4>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="ml-3" color="primary">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>Pode-se logar com CPF/CNPJ/Código Usuário.</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.LoginAFV" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerLoginAFV" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.LoginAFV ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerLoginAFV')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.LoginAFV" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.LoginAFV, comboBoxEnorme: true }" :disabled="!isEnabled.LoginAFV" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="funcionalidade-container">
                <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            Ação Política de Vendas
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.Politica" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerPoliticaVendas" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.Politica ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerPoliticaVendas')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.Politica" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.Politica, comboBoxEnorme: true }" :disabled="!isEnabled.Politica" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="funcionalidade-container">
                <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            Acessar via Link Externo (Área do Parceiro)
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.LoginLinkExterno" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerLink" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.LoginLinkExterno ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerLink')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.LoginLinkExterno" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.LoginLinkExterno, comboBoxEnorme: true }" :disabled="!isEnabled.LoginLinkExterno" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="funcionalidade-container">
                <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            Ação corrigir e-mail pós venda
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.ReenvioEmail" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerEmail" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.ReenvioEmail ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerEmail')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.ReenvioEmail" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.ReenvioEmail, comboBoxEnorme: true }" :disabled="!isEnabled.ReenvioEmail" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="funcionalidade-container">
                <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            Autenticação GNs e RCs
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.AutenticacaoHierarquia" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerGNRC" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.AutenticacaoHierarquia ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerGNRC')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.AutenticacaoHierarquia" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.AutenticacaoHierarquia, comboBoxEnorme: true }" :disabled="!isEnabled.AutenticacaoHierarquia" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            Ação Reenviar contrato via WhatsApp Por Usuários
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="10" style="display: inline-flex">
                        <v-radio-group v-model="Options.Whatsapp" row style="margin-top: 7px; margin-right: -20px; padding-top: 0">
                            <v-radio label="Desabilitar" :value="0"></v-radio>
                            <v-radio label="Habilitar" :value="1"></v-radio>
                            <v-radio label="Habilitar para:" :value="2"></v-radio>
                        </v-radio-group>
                        <div ref="comboBoxContainerWpp" class="div--comboBox" :style="{ 'margin-bottom': isEnabled.WhatsApp ? '-26px !important' : '' }">
                            <DynamicSelect @input="scrollToBottom('comboBoxContainerWpp')" placeholder="Selecione os usuários" v-model="usuariosSelecionados.Whatsapp" endpoint="/dynamic-selects/usuarios/id" :class="{ isDisabled: !isEnabled.WhatsApp, comboBoxEnorme: true }" :disabled="!isEnabled.WhatsApp" confirm-on-clear />
                        </div>
                    </v-col>
                </v-row>
            </div>
            <ConfiguracoesPorPv ref="configuracoesPorPv" />
            <ConfiguracoesPorMarca ref="configuracoesPorMarca" />
            <div class="funcionalidade-container">
              <v-row>
                    <v-col cols="12" md="4">
                        <h4 class="text--gray parametros__sistema__h4">
                            CNPJ Alfanumérico
                        </h4>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="10" style="margin-top: -15px;">
                    <v-switch :true-value="1" :false-value="0" v-model="Options.CnpjAlfanumerico" :label="`CNPJ Alfanumérico: ${Options.CnpjAlfanumerico ? 'Habilitado' : 'Desabilitado'}`"></v-switch>
                  </v-col>
                </v-row>
            </div>
            <v-row>
                <v-col cols="10" class="mt-7"></v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition button-right" color="primary" rounded @click="salvarFuncionalidadesDoSistema">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row
            ><v-col cols="12" class="mt-7"></v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <h3>Configuração dígito de agência</h3>
            <v-row>
                <v-col cols="12" md="8">
                    Informe um banco para ocultar a possibilidade de incluir dígito de agência
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="10" style="display: inline-flex">
                    <div class="comboBox_container">
                        <Autocomplete class="comboBox" :items="banks" v-model="selectedBanks" item-text="textToShow" item-value="value" placeholder="Selecione os bancos" multiple hide-details confirm-on-clear />
                    </div>
                </v-col>
                <v-col cols="2" class="mt-7">
                    <v-btn class="transition" color="primary" rounded :disabled="blockBankConfig" @click="salvarConfiguracaoDigitoAgencia">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <h3>Configuração do tempo de duração para alertas</h3>

            <v-form ref="formConfigTempoAlertas">
                <v-row>
                    <v-col cols="10" md="8">
                        <m-text-field v-input-filter="[$filters.numeric]" v-model="error_alerts" maxlength="2" class="required" :rules="[$rules.notzero, $rules.required]" label="Tempo de duração, em segundos, para alerta de Erro:" outlined placeholder="Informe o tempo em segundos" />
                    </v-col>
                    <v-col cols="10" md="8">
                        <m-text-field v-input-filter="[$filters.numeric]" v-model="miscellaneous_alerts" maxlength="2" class="required" :rules="[$rules.notzero, $rules.required]" label="Tempo de duração, em segundos, para alertas de Sucesso, Aviso e Informativo:" outlined placeholder="Informe o tempo em segundos" />
                    </v-col>
                </v-row>
            </v-form>
            <v-row class="d-flex justify-end">
                <v-col cols="2">
                    <v-btn class="transition" color="primary" rounded @click="saveAlertConfiguration">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <h3>Configuração de quantidade de dias para expiração do link de pagamento</h3>
            <v-form ref="formConfigDiasExpiracaoVenda">
                <v-row>
                    <v-col cols="10" md="8">
                        <m-text-field v-input-filter="[$filters.numeric]" v-model="expiration_days" maxlength="3" class="required" :rules="[$rules.notzero, $rules.required]" label="Quantidade de dias para expiração de link:" outlined placeholder="Informe o tempo em dias" />
                    </v-col>
                </v-row>
            </v-form>
            <v-row class="d-flex justify-end">
                <v-col cols="2">
                    <v-btn class="transition" color="primary" rounded @click="saveExpirationDaysConfiguration">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <ConfiguracoesExpurgoPropostas></ConfiguracoesExpurgoPropostas>
        <v-divider></v-divider>
        <ConfigAgendamentoAnaliseInvalida></ConfigAgendamentoAnaliseInvalida>
        <v-divider></v-divider>
        <configuracao-unidades-negocio></configuracao-unidades-negocio>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { ValuesFunctionalities } from '@/plugins/constants'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import ConfiguracaoLimiteCotasReserva from '../../../fragments/ConfiguracoesGerais/ConfiguracaoLimiteCotasReserva.vue'
  import ConfiguracaoLimiteCotasFluxoComum from '../../../fragments/ConfiguracoesGerais/ConfiguracaoLimiteCotasFluxoComum.vue'
  import ConfiguracoesExpurgoPropostas from '../expurgo-propostas/ConfiguracoesExpurgoPropostas.vue'
  import ConfiguracaoUnidadesNegocio from '../../../fragments/ConfiguracoesGerais/ConfiguracaoUnidadesNegocio.vue'
  import ConfiguracoesPorMarca from './ConfiguracoesPorMarca.vue'
  import ConfiguracoesPorPv from './ConfiguracoesPorPv.vue'
  import ConfigAgendamentoAnaliseInvalida from '../credit-analysis/ConfigAgendamentoAnaliseInvalida.vue'

  export default {
    name: 'ParametrosSistema',
    components: { ConfiguracaoLimiteCotasReserva, ConfiguracaoLimiteCotasFluxoComum, ConfiguracoesExpurgoPropostas, ConfiguracaoUnidadesNegocio, ConfiguracoesPorMarca, ConfiguracoesPorPv, ConfigAgendamentoAnaliseInvalida },
    data: () => ({
      switch1: false,
      Options: {
        Politica: 0,
        Whatsapp: 0,
        ReenvioEmail: 0,
        LoginLinkExterno: 0,
        LoginAFV: 0,
        AutenticacaoHierarquia: 0,
        CnpjAlfanumerico: 0
      },
      OptionsEach: ['Politica', 'Whatsapp', 'ReenvioEmail', 'LoginAFV', 'LoginLinkExterno', 'AutenticacaoHierarquia', 'CnpjAlfanumerico'],
      porcentagem: 0,
      valor_idade: 16,
      percentual_minimo_venda: 0,
      percentual_minimo_faturamento: 0,
      assinatura_obrigatoria_grupos_pontuais: false,
      assinatura_obrigatoria_grupos_convencionais: false,
      limite_cotas_para_reservar_ativo: false,
      quantidade_cotas_reservar: 1,
      percentual_cotas_disponiveis_ativo: false,
      percentual_cotas_disponiveis: 1,
      exibe_assinatura_pagamento: 1,
      banks: [],
      blockBankConfig: false,
      selectedBanks: [],
      usuarios: [],
      usuariosSelecionados: {
        Whatsapp: [],
        Politica: [],
        ReenvioEmail: [],
        LoginLinkExterno: [],
        LoginAFV: [],
        AutenticacaoHierarquia: []
      },
      NomeFuncionalidade: {
        WhatsApp: 'Whatsapp',
        Politica: 'Politica',
        ReenvioEmail: 'ReenvioEmail',
        LoginLinkExterno: 'LoginLinkExterno',
        LoginAFV: 'LoginAFV',
        AutenticacaoHierarquia: 'AutenticacaoHierarquia',
        CnpjAlfanumerico: 'CnpjAlfanumerico'
      },
      NomeColunas: {
        Politica: 'politica_vendas',
        Whatsapp: 'reenvio_whatsapp',
        ReenvioEmail: 'reenvio_email',
        LoginLinkExterno: 'login_link_externo',
        LoginAFV: 'acesso_afv',
        AutenticacaoHierarquia: 'autenticacao_hierarquia'
      },
      isEnabled: {
        WhatsApp: false,
        Politica: false,
        ReenvioEmail: false,
        LoginLinkExterno: false,
        LoginAFV: false,
        AutenticacaoHierarquia: false
      },
      error_alerts: 0,
      miscellaneous_alerts: 0,
      expiration_days: 0
    }),
    computed: {
      MAX_USUARIOS: () => 80
    },
    watch: {
      usuariosSelecionados: {
        handler (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            Object.keys(newVal).forEach((key) => {
              if (JSON.stringify(newVal[key]) !== JSON.stringify(oldVal[key])) {
                const refName = `comboBoxContainer${key}`
                this.scrollToBottom(refName)
              }
            })
          }
        },
        deep: true
      },
      'Options.LoginAFV' () {
        if (this.Options.LoginAFV === ValuesFunctionalities.DESABILITAR || this.Options.LoginAFV === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.LoginAFV = false
        } else {
          this.isEnabled.LoginAFV = true
        }
      },
      'Options.Whatsapp' () {
        if (this.Options.Whatsapp === ValuesFunctionalities.DESABILITAR || this.Options.Whatsapp === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.WhatsApp = false
        } else {
          this.isEnabled.WhatsApp = true
        }
      },
      'Options.Politica' () {
        if (this.Options.Politica === ValuesFunctionalities.DESABILITAR || this.Options.Politica === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.Politica = false
        } else {
          this.isEnabled.Politica = true
        }
      },
      'Options.ReenvioEmail' () {
        if (this.Options.ReenvioEmail === ValuesFunctionalities.DESABILITAR || this.Options.ReenvioEmail === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.ReenvioEmail = false
        } else {
          this.isEnabled.ReenvioEmail = true
        }
      },
      'Options.AutenticacaoHierarquia' () {
        if (this.Options.AutenticacaoHierarquia === ValuesFunctionalities.DESABILITAR || this.Options.AutenticacaoHierarquia === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.AutenticacaoHierarquia = false
        } else {
          this.isEnabled.AutenticacaoHierarquia = true
        }
      },
      'Options.LoginLinkExterno' () {
        if (this.Options.LoginLinkExterno === ValuesFunctionalities.DESABILITAR || this.Options.LoginLinkExterno === ValuesFunctionalities.HABILITAR) {
          this.isEnabled.LoginLinkExterno = false
        } else {
          this.isEnabled.LoginLinkExterno = true
        }
      }
    },
    async mounted () {
      Promise.all([this.loadExpirationDays(), this.SetarDadosFuncionalidades(), this.loadBancos(), this.loadDesconto(), this.loadIdade(), this.loadConfiguracao(), this.loadPercentualLimiteRenda(), this.loadPercentualLimiteFaturamento(), this.loadTempoAlertas()])
    },
    methods: {
      async loadTempoAlertas () {
        this.$http
          .get('/painel/tempo_alertas')
          .then(result => {
            this.error_alerts = result.data.tempo_alertas_erros
            this.miscellaneous_alerts = result.data.tempo_alertas_variados
          })
          .catch(() => {
            notification('warning', 'Ocorreu um erro ao carregar a configuração de alertas.')
          })
      },
      async loadExpirationDays () {
        this.$http.get('/painel/expiration_days')
          .then(result => {
            this.expiration_days = result.data.expiration_days
          })
          .catch(() => {
            notification('warning', 'Ocorreu um erro ao carregar a configuração de alertas.')
          })
      },
      async loadBancos () {
        this.$http
          .get('/banks_to_config')
          .then(result => {
            this.banks = result.data.banks
            const blockedBanks = this.banks.filter(bank => bank.bloquear_digito && bank.bloquear_digito)
            this.selectedBanks = blockedBanks.map(bank => bank.value)
          })
          .catch(() => {
            this.blockBankConfig = true
            notification('error', `Ocorreu um erro ao carregar os bancos.\nTente novamente mais tarde.`)
          })
      },
      async salvarConfiguracaoDigitoAgencia () {
        const payload = {
          banks: this.selectedBanks
        }
        this.$http.put('/banks_digit_config', payload)
          .then(result => {
            notification('success', 'Configuração realizada com sucesso!')
          })
          .catch(() => {
            notification('error', 'Ocorreu um erro ao salvar os bancos. Tente novamente mais tarde.')
          })
      },
      async saveExpirationDaysConfiguration () {
        if (!this.$refs.formConfigDiasExpiracaoVenda.validate()) {
          return
        }
        const payload = {
          expiration_days: this.expiration_days
        }
        this.$http.put('/painel/expiration_days', payload)
          .then(result => {
            notification(AlertTypes.SUCCESS, 'Tempo de expiração da venda atualizado com sucesso! Após essa alteração, links de pagamentos antigos expirarão conforme configurado')
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Falha ao atualizar o tempo de expiração da venda, tente novamente mais tarde.')
          })
      },
      async saveAlertConfiguration () {
        if (!this.$refs.formConfigTempoAlertas.validate()) {
          return
        }
        const payload = {
          error_alert: this.error_alerts,
          miscellaneous_alert: this.miscellaneous_alerts
        }
        this.$http.put('/painel/tempo_alertas', payload)
          .then(result => {
            notification('success', 'Tempo de duração dos alertas atualizado com sucesso!')
          })
          .catch(() => {
            notification('error', 'Falha ao atualizar a duração dos alertas, tente novamente mais tarde.')
          })
      },
      loadDesconto () {
        this.$http
          .get('/configuracaopagamento/get')
          .then(result => {
            if (result.data) {
              this.switch1 = result.data.ativo
              this.porcentagem = result.data.porcentagem
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar as reservas!'))
      },
      loadIdade () {
        this.$http
          .get('/configuracaoidade/get')
          .then(result => {
            if (result.data) {
              this.valor_idade = result.data.valor_idade
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a configuração de idade!'))
      },
      loadConfiguracao () {
        this.$http
          .get('/configuracao/get')
          .then(result => {
            if (result.data) {
              this.assinatura_obrigatoria_grupos_pontuais = result.data.assinatura_obrigatoria_grupos_pontuais
              this.assinatura_obrigatoria_grupos_convencionais = result.data.assinatura_obrigatoria_grupos_convencionais
              this.exibe_assinatura_pagamento = result.data.exibe_asssinatura_obrigatoria_tela_pagamento ? 0 : 1
              this.limite_cotas_para_reservar_ativo = result.data.limite_cotas_para_reservar_ativo
              this.quantidade_cotas_reservar = result.data.quantidade_cotas_reservar
              this.percentual_cotas_disponiveis_ativo = result.data.percentual_cotas_disponiveis_ativo
              this.percentual_cotas_disponiveis = result.data.percentual_cotas_disponiveis
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a configuração!'))
      },
      loadPercentualLimiteRenda () {
        this.$http
          .get(`/parametrizacao/load_parametrizacao/limite_comprometimento_renda`)
          .then(result => {
            if (result.data) {
              this.percentual_minimo_venda = result.data.valor
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a configuração de limite de renda!'))
      },
      loadPercentualLimiteFaturamento () {
        this.$http
          .get('/parametrizacao/load_parametrizacao/limite_comprometimento_faturamento')
          .then(result => {
            if (result.data) {
              this.percentual_minimo_faturamento = result.data.valor
            }
          })
          .catch(() => notification(AlertTypes.ERROR, 'Não foi possível buscar a configuração de limite de faturamento!'))
      },
      async inserir () {
        try {
          await this.$http.post('/painel/configuracaopagamento/inserir', {
            porcentagem: this.porcentagem,
            ativo: this.switch1
          })
          notification(AlertTypes.SUCCESS, 'Desconto atualizado com sucesso.')
        } catch (e) {
          notification('error', e, 'Não foi possível atualizar o desconto!')
        }
      },
      async inserirAssinaturaObrigatoria () {
        try {
          await this.$http.post('/painel/configuracao/inserir', {
            assinatura_obrigatoria_grupos_pontuais: this.assinatura_obrigatoria_grupos_pontuais,
            assinatura_obrigatoria_grupos_convencionais: this.assinatura_obrigatoria_grupos_convencionais
          })
          notification(AlertTypes.SUCCESS, 'Obrigatoriedade da assinatura atualizado com sucesso.')
        } catch (e) {
          notification('error', e, 'Não foi possível atualiar a obrigatoriedade da assinatura!')
        }
      },
      async inserirExibirAssinaturaObrigatoria () {
        try {
          await this.$http.post('/painel/configuracaoasssinatura/inserir', {
            exibe_asssinatura_obrigatoria_tela_pagamento: this.exibe_assinatura_pagamento !== 1
          })
          notification(AlertTypes.SUCCESS, 'Exibição Obrigatoriedade da assinatura atualizado com sucesso.')
        } catch (e) {
          notification('error', e, 'Não foi possível atualizar a obrigatoriedade da assinatura')
        }
      },
      async inserirIdade () {
        if (this.valor_idade > 0 && this.valor_idade < 151) {
          try {
            await this.$http.post('/painel/configuracaoidade/inserir', {
              valor_idade: this.valor_idade,
              ativo: true
            })
            notification(AlertTypes.SUCCESS, 'Idade atualizada com sucesso.')
          } catch (e) {
            notification('error', e, 'Não foi possível atualizar a idade')
          }
        } else {
          notification(AlertTypes.WARN, 'A idade deve ser até 150.')
        }
      },
      async salvarLimiteComprometimentoRenda () {
        try {
          await this.$http.post('/painel/parametrizacao/salvar', {
            valor: this.percentual_minimo_venda,
            parametro: 'limite_comprometimento_renda'
          })
          notification(AlertTypes.SUCCESS, 'Limite de compromentimento de renda atualizado com sucesso.')
        } catch (e) {
          notification('error', e, 'Não foi possível atualizar o limite de compromentimento de renda')
        }
      },
      async salvarLimiteComprometimentoFaturamento () {
        if (!this.percentual_minimo_faturamento || this.percentual_minimo_faturamento === '') {
          notification(AlertTypes.ERROR, 'Informe um valor entre 0 e 100% para o faturamento mínimo.')
          return
        }
        try {
          await this.$http.post('/painel/parametrizacao/salvar', {
            valor: this.percentual_minimo_faturamento,
            parametro: 'limite_comprometimento_faturamento'
          })
          notification(AlertTypes.SUCCESS, 'Limite de comprometimento de faturamento atualizado com sucesso.')
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível atualizar o limite de comprometimento de faturamento.')
        }
      },
      ordenar (a, b) {
        if (a.nome < b.nome) return -1
        if (a.nome > b.nome) return 1
        return 0
      },
      limparCampos () {
        let options = this.OptionsEach
        options.forEach(option => {
          if (this.Options[option] !== ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados[option].length > 0) {
            this.usuariosSelecionados[option] = []
          }
        })
      },
      async salvarFuncionalidadesDoSistema () {
        // Checagem para o usuário não enviar usuários específicos sem nada no input
        if ((this.Options.Whatsapp === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.Whatsapp.length === ValuesFunctionalities.DESABILITAR) || (this.Options.Politica === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.Politica.length === ValuesFunctionalities.DESABILITAR) || (this.Options.ReenvioEmail === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.ReenvioEmail.length === ValuesFunctionalities.DESABILITAR) || (this.Options.LoginLinkExterno === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.LoginLinkExterno.length === ValuesFunctionalities.DESABILITAR) || (this.Options.LoginAFV === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.LoginAFV.length === ValuesFunctionalities.DESABILITAR) || (this.Options.AutenticacaoHierarquia === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.AutenticacaoHierarquia.length === ValuesFunctionalities.DESABILITAR)) {
          notification(AlertTypes.WARN, 'Necessário informar ao menos 1 usuário para acesso das funcionalidades listadas.')
          return
        }
        /*
                   Limpa os campos caso o usuário tenha selecionado Habilitado para:, selecionado usuários e depois marcado outra
                   opção, torna a experiência do usuário mais agradável.
                   */
        this.limparCampos()
        try {
          await this.$http
            .post('/painel/configuracao/funcionalidades/salvar', {
              options: this.Options,
              usuarios: this.usuariosSelecionados,
              nome_funcionalidade: this.NomeFuncionalidade,
              nome_colunas: this.NomeColunas
            })

          await this.$refs.configuracoesPorPv.salvarRestricoesPvs()
          await this.$refs.configuracoesPorMarca.salvarRestricoesMarcas()

          notification(AlertTypes.SUCCESS, 'Parametrizações atualizadas com sucesso.')
        } catch (e) {
          notification('error', 'Erro ao atualizar as parametrizações')
        }
      },
      async SetarDadosFuncionalidades () {
        try {
          const responseFuncionalidades = await this.$http.post('/painel/configuracao/funcionalidades/get', { nome_colunas: this.NomeColunas })
          const dataFuncionalidades = responseFuncionalidades.data[0]
          dataFuncionalidades.forEach(dado => {
            this.Options[dado.funcionalidade] = dado.config
            this.usuariosSelecionados[dado.funcionalidade] = JSON.parse(dado.usuarios)
          })
        } catch (e) {
          notification('error', 'Erro ao setar funcionalidade no painel administrativo')
        }
      },
      scrollToBottom (refName) {
        this.$nextTick(() => {
          const container = this.$refs[refName]

          if (container && container.scrollHeight > container.offsetHeight) {
            const comboBoxRect = container.getBoundingClientRect()
            const windowHeight = window.innerHeight

            const espacoAbaixo = windowHeight - comboBoxRect.bottom
            const espacoAcima = comboBoxRect.top

            if (espacoAbaixo >= espacoAcima) {
              container.scrollTop = container.scrollHeight
            } else {
              container.scrollTop = 0
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
.v-card__text {
    margin-top: 8px;
}

.row {
    align-items: center;
}

.v-input__control {
    align-items: center;
    justify-items: center;
}

.v-input {
    display: flex;
    align-items: center;
}

.v-input--selection-controls {
    margin-top: 1.5rem;
}

.mt-7 {
    align-self: flex-end;
}

.inline-anti-quebra-layout {
    display: inline-flex;
}

h3 {
    margin-bottom: 20px;
}

.div--comboBox {
    width: 65%;
    max-height: 300px;
    overflow-y: auto !important;
}

.comboBoxEnorme {
    max-width: 100%;
    margin-bottom: 0px !important;
    max-height: none;
    margin: 16px !important;
    overflow-y: auto !important;
}

.comboBox_container {
    width: 100%;
    max-height: fit-content;
}

.comboBox {
    width: 100%;
    overflow: auto;
    margin: 16px;
    margin-left: 0px !important;
    max-height: fit-content;
}

.parametros__sistema__h4 {
    margin-top: 15px;
    margin-bottom: 15px;
}

.isDisabled {
    overflow: hidden !important;
    border-radius: 10px;
    background-color: #efefef !important;
}

@media (max-width: 1360px) {
    .comboBoxEnorme {
        max-width: 40%;
        margin-top: 0px !important;
        margin: 20px !important;
        overflow-y: auto !important;
    }
}

@media (max-width: 1600px) {
    .comboBoxEnorme {
        max-width: 100%;
        margin-top: 0px !important;
        padding-top: 0;
        margin: 16px !important;
        overflow-y: auto !important;
    }

    .div--comboBox {
        max-width: 55%;
        max-height: 260px;
        overflow-y: auto !important;
    }
}
</style>
